export const VUE_APP_SSO_LINK = process.env.VUE_APP_SSO_LINK || 'http://172.16.100.22:3000/api/'
export const VUE_APP_INSURANCE_LINK = process.env.VUE_APP_INSURANCE_LINK || 'http://172.16.100.22:3000/api/'
export const VUE_APP_WEBSITE_LINK = process.env.VUE_APP_WEBSITE_LINK || 'http://172.16.100.22:8006/api/'
